// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-n_hp","advertDetailService__price":"c-n_hq"};